import { lazy } from 'react';

export const ObjectAccountingPageLazy = lazy(
  () => import('./ObjectAccountingPage')
);
